import { render, staticRenderFns } from "./regiest.vue?vue&type=template&id=19b8afc5&scoped=true&"
import script from "./regiest.vue?vue&type=script&lang=js&"
export * from "./regiest.vue?vue&type=script&lang=js&"
import style0 from "./regiest.vue?vue&type=style&index=0&id=19b8afc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8afc5",
  null
  
)

export default component.exports